import { authorizedApi } from './index';

export const discountCodesApi = authorizedApi.injectEndpoints({
  endpoints: (builder) => ({
    createDiscountCode: builder.mutation({
      query: (discountCodeData) => ({
        url: '/globetopper/admin/create-discount-code',
        method: 'POST',
        body: discountCodeData,
      }),
    }),
  }),
});

export const { useCreateDiscountCodeMutation } = discountCodesApi;
